import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { Typography, Spin, Card } from "antd";
import axios from "axios";
import { config } from "../config";
import "../pages/DesaCantik/DesaCantik.scss";

const { Title } = Typography;

const DesaCantikCarousel = () => {
  const [carouselData, setCarouselData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const namaDomain = window.location.href;

        const res = await axios.get(
          `${config.BASE_URL}organization/findContentOrganization?namaDomain=${namaDomain}`
        );

        const galeri = res.data?.data?.galeriDesaCantik || [];

        const formatted = galeri.map((item) => {
          const path = item.pathLink?.trim();

          const fullUrl = path
            ? `${config.BASE_URL}getReferenceFile?pathFile=${encodeURIComponent(
                item.pathLink
              )}`
            : "https://source.unsplash.com/800x400/?village";

          return {
            deskripsi: item.deskripsi || "Deskripsi tidak tersedia",
            backgroundImage: fullUrl, // langsung pakai URL aman
          };
        });

        setCarouselData(formatted);
      } catch (error) {
        console.error("Gagal ambil data galeriDesaCantik:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  };

  const antIcon = <Spin style={{ fontSize: 40, color: "#FF5C30" }} spin />;

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "50px 0" }}>
        <Spin indicator={antIcon} />
      </div>
    );
  }

  return (
    <Slider {...settings} className="desa-cantik-slider">
      {carouselData.map((item, index) => (
        <div key={index}>
          <Card
            bordered={false}
            className="carousel-card"
            style={{
              backgroundImage: `
                linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0) 60%),
                url(${item.backgroundImage})
              `,
            }}
          >
            <Title level={3} className="carousel-text">
              {item.deskripsi}
            </Title>
          </Card>
        </div>
      ))}
    </Slider>
  );
};

export default DesaCantikCarousel;
